<template>
  <div>
    <TextFormGroup
        v-model="data.headline"
        name="headline"
        label="Headline"
        :error="(errors.headline || [])[0]"
    />

    <CkEditorFormGroup
        v-model="data.content"
        name="content"
        label="Content"
        :error="(errors.content || [])[0]"
    />
  </div>
</template>

<script>
import CkEditorFormGroup from "../../../../vendor/forms/FormGroups/Block/CkEditor.vue";
import TextFormGroup from "../../../../vendor/forms/FormGroups/Block/Text.vue";

export default {
  components: {CkEditorFormGroup, TextFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    }
  },

  computed: {
    data: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
